import React from 'react';

import ImageHero from '../image-hero/image-hero';
import CompanyHeader from './company-header/company-header';
import CompanyExecutive from './company-executive/company-executive';
import CompanyStroke from '../company-stroke/company-stroke';
import CompanyMatrix from './company-matrix/company-matrix';

import ImageHeroContent from '../../lib/company-content-src/image-hero-content';
import CompanyExecutiveContent from '../../lib/company-content-src/company-executive-content';
import CompanyBoardContent from '../../lib/company-content-src/company-board-content';
import CompanyBoardObserverContent from '../../lib/company-content-src/company-board-observer-content';

const LeadershipPage = () => (
  <div>
    <ImageHero
      preheader={ImageHeroContent.leadership.preheader}
      title={ImageHeroContent.leadership.title}
      body={ImageHeroContent.leadership.body}
      bodyMobile={ImageHeroContent.leadership.bodyMobile}
      buttonText={ImageHeroContent.leadership.buttonText}
      backgroundClassName={ImageHeroContent.leadership.backgroundClassName}
    />
    <CompanyHeader headerText="Executive Team" />
    <CompanyExecutive {...CompanyExecutiveContent} />
    <CompanyStroke />
    <CompanyHeader headerText="Board of Directors" />
    <CompanyMatrix {...CompanyBoardContent} />
    <CompanyStroke />
    <CompanyHeader headerText="Board Observers" />
    <CompanyMatrix {...CompanyBoardObserverContent} />
  </div>
);

LeadershipPage.displayName = 'Leadership Page';

export default LeadershipPage;
